import { debounce } from './debounce'
import { lenis } from './lenis-smooth-scroll'

const root = document.documentElement
let headerHeight = getComputedStyle(root)
    .getPropertyValue('--header-height')
    .replace('px', '')

window.addEventListener(
    'resize',
    debounce(function (event) {
        headerHeight = getComputedStyle(root)
            .getPropertyValue('--header-height')
            .replace('px', '')
    })
)

// smooth scroll for anchor tags
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault()
        const elem = document.querySelector(this.getAttribute('href'))

        if (window.innerWidth > 1024) {
            lenis.scrollTo(elem, { offset: -headerHeight })
        } else {
            scrollToId(elem.id)
        }
    })
})

// smooth scroll without anchor tags
const scrollFromElements = [].slice.call(
    document.querySelectorAll('.scrollFrom')
)
const scrollToElements = [].slice.call(document.querySelectorAll('.scrollTo'))

scrollFromElements.forEach((element, i) => {
    element.addEventListener(
        'click',
        function () {
            if (window.innerWidth > 1024) {
                if (scrollToElements[i]) {
                    lenis.scrollTo(scrollToElements[i], {
                        offset: -headerHeight,
                    })
                } else {
                    lenis.scrollTo(scrollToElements[i - 1], {})
                }
            } else {
                if (scrollToElements[i]) {
                    scrollToElement(scrollToElements[i], -headerHeight)
                } else {
                    scrollToElement(scrollToElements[i - 1])
                }
            }
        },
        false
    )
})

function scrollToId(id) {
    const element = document.getElementById(id)
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
    }
}

function scrollToElement(elem, offset = 0) {
    const y = elem.getBoundingClientRect().top + window.pageYOffset + offset
    window.scrollTo({ top: y, behavior: 'smooth' })
}
